/**
 * Lề của bảng nằm trong một khối bo góc (`Tile` của `components/shared/Bento`) — port `bang.ts` native.
 *
 * Bảng `small` của antd để ô đầu và ô cuối cách mép 8px; trong một khối có `TileHeader` thụt 20px thì hai mép trái
 * lệch nhau. Đẩy ô đầu và ô cuối vào đúng 20px để bảng thẳng hàng với tiêu đề khối. Truyền vào `className` của
 * `DataTable`.
 */
export const LE_BANG =
  '[&_.ant-table-cell:first-child]:!pl-5 [&_.ant-table-cell:last-child]:!pr-5 [&_.ant-table-thead_.ant-table-cell]:!py-3';

/** Khối chứa bảng: cắt nội dung theo góc bo, để nền tiêu đề bảng không lòi ra ngoài viền. */
export const KHOI_BANG = 'overflow-hidden';
